import { aclByArea, roleByArea } from "$root/functional-areas/acl/checkers/all";
import { validateACLPermissions } from "$root/functional-areas/acl/checkers/shared";
import { getCurrentUser } from "$root/functional-areas/user";
import type { ReferenceItem } from "$root/pages/PortfoliosStudio/common";
import type { ValidationResult } from "../common/types";
import type { ReferenceActionUnavailableReason, ReferenceListAction } from "./types";

export const referenceListActionValidators: Record<
	ReferenceListAction,
	(reference: ReferenceItem) => ValidationResult<ReferenceActionUnavailableReason>
> = {
	delete(reference) {
		const user = getCurrentUser();

		if ((reference.linkedPortfolio?.length ?? 0) > 0) {
			return [false, "LINKED_TO_PORTFOLIO"];
		}

		if (!aclByArea.targetPortfolio.canDelete(user.id, reference.richAcl?.acl ?? [])) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		return [true, undefined];
	},
	share(reference) {
		const user = getCurrentUser();

		if (!reference.richAcl?.acl) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		if (!validateACLPermissions(user.id, reference.richAcl.acl, roleByArea.targetPortfolio.OWNER)) {
			return [false, "ACL_OWNER_REQUIRED"];
		}

		return [true, undefined];
	},
	export(reference) {
		if (reference.type === "LegacyBenchmark") {
			return [false, "LEGACY_BENCHMARK"];
		}

		return [true, undefined];
	},
};
